

export class ValidarCFViewModel {

    public IdSolicitudEx: number;
    public Token: string;
    public IdDocSede: string;
    public Url: string;
    public VerisonSede: string;
}

export class CertificadoVerificadoViewModel {

    public IdSolicitudEx: number;
    public Token: string;
    public EsCexVegWeb: boolean;
}

//export class DownloadFileFromSedeViewModel {

//    public IdSolicitudEx: number;
//    public NumeroCertificado: string;

//}
